// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { asRejectingValidator } from "@altostra/type-validations/lib/RejectionReasons";
import { string } from "@altostra/type-validations/lib/primitives";

import type { ISODateTimeTzString } from "@lib/time";

// custom validator for ISODateTimeTzString
const ISO_DATE_TIME_TZ_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}[+-]\d{2}:\d{2}$/;

const isISODateTimeTzString = asRejectingValidator(
  (value: unknown): value is ISODateTimeTzString => typeof value === "string" && ISO_DATE_TIME_TZ_REGEX.test(value),
  "ISODateTimeTzString"
);

export const isPostAlloysAdjustCustomEventsAppGroupIdResult = objectOf({
  integration: anyOf(
    objectOf({
      c_id: string,
      ag_id: string,
      integration_id: string,
      connected_by: string,
      api_key: string,
      connected_at: isISODateTimeTzString,
    }),
    objectOf({})
  ),
});

export const isGetAlloysAdjustCustomEventsAppGroupIdResult = objectOf({
  integration: anyOf(
    objectOf({
      c_id: string,
      ag_id: string,
      integration_id: string,
      connected_by: string,
      api_key: string,
      connected_at: isISODateTimeTzString,
    }),
    objectOf({})
  ),
});
